// src/hooks/useStatusBarStyle.ts

import { useEffect } from 'react'
import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'
import { useTheme } from '../store/themeContext'

const useStatusBarStyle = () => {
  const { darkMode } = useTheme()

  useEffect(() => {
    const setStatusBarStyle = async () => {
      if (Capacitor.getPlatform() === 'ios') {
        try {
          await StatusBar.setStyle({ style: darkMode ? Style.Dark : Style.Light })
        } catch (err) {
          console.error('Failed to set status bar style:', err)
        }
      } else if (Capacitor.getPlatform() === 'android') {
        try {
          await StatusBar.setStyle({ style: darkMode ? Style.Dark : Style.Light })
        } catch (err) {
          console.error('Failed to set edge-to-edge style:', err)
        }
      }
    }
    setStatusBarStyle().then((result) => {
      return result
    })
    .catch(()=> {
      console.error('Error setting status bar style:')
    })
  }, [darkMode])
}

export default useStatusBarStyle
